const { findIndex } = require('lodash');

class FulfilmentTimetableController {
    constructor(moveFocus, addressService, settings) {
        this.moveFocus = moveFocus;
        this.addressService = addressService;
        this.settings = settings;
    }

    $onInit() {
        this.initialize();
        this.moveFocus('#fulfilmentTimetable');
    }

    $onChanges(changed) {
        if (changed.timeTable) {
            this.selectFirstAvailableDate();
        }
    }

    getFulfilmentMethod() {
        return this.isDelivery ? 'delivery' : this.settings.fulfilmentMethod.timetablePickupName;
    }

    initialize() {
        this.availableTimes = this.availableTimes || [];

        if (this.reservedDate) {
            this.savedTime = {
                time: this.reservedTime,
                date: this.reservedDate,
            };
        }

        this.IsExpressDeliveryUnavailable = false;
        this.expressDeliveryUnavailableMessage = '';
    }

    selectFirstAvailableDate() {
        if (this.timeTable && this.timeTable.length > 0) {
            this.initialize();

            // get index of first available date
            let index = (this.savedDate && this.savedDeliveryWindowId)
                ? findIndex(this.timeTable, deliveryWindow => deliveryWindow.Date.substring(0, 11) === this.savedDate.substring(0, 11))
                : findIndex(this.timeTable, date => date.Available);

            // _.findIndex will return -1 if the date list is unretrievable.
            // This will set index to 0 if no dates are available.
            index = index > 0 ? index : 0;

            // set focus on the first available date or first item
            this.moveFocus('.fulfilmentTimetable-timeSelectorItem.available:first');

            this.selectedDate = this.timeTable[index];
            this.availableTimes = this.selectedDate.Times;

            this.IsExpressDeliveryUnavailable = this.selectedDate.IsExpressDeliveryExhausted;
            this.expressDeliveryUnavailableMessage = this.selectedDate.ExpressWindowClosedText;
        }
    }

    saveSelectedDate(selectedDate) {
        if (this.onSetFulfilmentDate) {
            this.onSetFulfilmentDate({ selectedDate });
        }
        this.selectedDate = selectedDate;
        this.availableTimes = this.selectedDate.Times;
    }

    setDate(selectedDate) {
        this.selectedDate = selectedDate;
        this.availableTimes = this.selectedDate.Times;

        this.moveFocus(this.selectedDate.Available
            ? '#fulfilmentTimetableTime'
            : '.fulfilmentTimetable ._no-window');
    }

    setTime(fulfilmentTime) {
        this.saveSelectedDate(this.selectedDate);
        this.selectedTime = fulfilmentTime;

        if (this.onSetFulfilmentTime) {
            this.onSetFulfilmentTime({ fulfilmentTime });
        }
    }

    screenReaderLabelForDeliveryTime(fulfilmentTime) {
        let labelTxt = `${fulfilmentTime.TimeWindow}.`;
        let priceTxt = '';
        const isSelectedDateEligibleForDeliverySaver = this.selectedDate && this.selectedDate.EligibleForDeliverySaver;
        if (!isSelectedDateEligibleForDeliverySaver && fulfilmentTime.Price !== undefined) {

            if (!(fulfilmentTime.Price > 0)) {
                priceTxt = ' free';
            } else {
                const isDiscountedPrice = fulfilmentTime.SalePrice < fulfilmentTime.Price;
                if (isDiscountedPrice) {
                    priceTxt = ` Was $${fulfilmentTime.Price} now $${fulfilmentTime.SalePrice}`;
                } else {
                    priceTxt = ` $${fulfilmentTime.Price}`;
                }
            }

        } else {
            priceTxt = ' free';
        }

        if (fulfilmentTime.IsKeptOpenForRewardsPlus) {
            labelTxt = `${labelTxt}${priceTxt}. Was ${fulfilmentTime.NormalAllocationStatus}, `;
            labelTxt = `${labelTxt}${this.settings.delivery.deliveryWindowReservedMessage}. `;
        } else {
            labelTxt = `${labelTxt}${priceTxt}. ${fulfilmentTime.Status}`;
        }

        if (this.selectedTime === fulfilmentTime) {
            labelTxt += ' selected';
        }

        const needToConfirmReminder = 'Press enter to confirm your selection.';
        if (fulfilmentTime.Status !== 'Closed') {
            labelTxt += needToConfirmReminder;
        }
        return labelTxt;
    }

    moveFocusToFirstTimeslot() {
        if (this.availableTimes.length > 0) {
            this.moveFocus(`#${this.availableTimes[0].Id}`);
        }
    }
}

FulfilmentTimetableController.$inject = ['MoveFocus', 'AddressService', 'Settings'];

const fulfilmentTimetableComponentDefinition = {
    bindings: {
        timeTable: '<',
        reservedDate: '<',
        reservedTime: '<',
        onSetFulfilmentDate: '&?',
        onSetFulfilmentTime: '&?',
        savedDate: '@',
        savedDeliveryWindowId: '@',
        isDelivery: '<',
    },
    controller: FulfilmentTimetableController,
    template: require('./fulfilment-timetable.component.html').trim(),
};

module.exports = {
    FulfilmentTimetableController,
    fulfilmentTimetableComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/fulfilment/timeslots/fulfilment-timetable.component.js